import { Widget, WidgetOrRoot } from '../../Widget';

export function hasChildren(
  widget: WidgetOrRoot,
): widget is WidgetOrRoot & { children: Widget[] } {
  return 'children' in widget;
}
